import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PSPDFKit from '../pspdfkit';
import {
  getOrder,
  getForms,
  getCampaignFormData,
  getDocumentArrayBuffer
} from '../../api/choiceforms';
/**
 * need button to save changes/move to the next step
 *   pass in functino so we can call when done
 *
 * url client/order
 * call out to client/fillableforms/order to get list of forms we need to fill out
 * get the first form and display
 * on submit capture data as formid/whatever
 * go to next
 * when done submit to client/fillableform/*orderid
 * redirect to the page that is returned
 */

const baseUrl = `${window.location.protocol}//${window.location.host}/${
  process.env.PUBLIC_URL
}`;

interface ChoiceViewerState {
  completedForms: Record<string, any>;
  client?: string;
  currentForm?: number;
  forms?: any[];
  finishedLoading?: boolean;
  orderid?: string;
  xfdf?: string;
  currentFormId?: any;
  content?: ArrayBuffer;
  host?: string;
  error?: boolean;
  errorMessage?: any;
}

export function ChoiceViewer() {
  const params = useParams();
  const [state, setState] = useState<ChoiceViewerState>({
    completedForms: {}
  });

  useEffect(
    () => {
      const loadData = async () => {
        console.log(params);
        const orderid = params.superid;
        const client = params.client;
        const formid = params.formid;
        let parsedOrderid = orderid;
        let refKey = '';
        let taskId = '';
        let studentId = '';
        if (
          orderid.indexOf('_reference') !== -1 &&
          orderid.split('_').length > 2
        ) {
          parsedOrderid = orderid.split('_')[0];
          refKey = orderid.split('_')[2];
        } else if (orderid.indexOf('_campaign') !== -1) {
          taskId = orderid.split('_')[0];
          studentId = orderid.split('_')[2];
        }

        let results;
        if (taskId === '') {
          results = await getOrder(client, parsedOrderid);
        } else {
          results = await getCampaignFormData(client, taskId, studentId);
        }
        console.log(results);
        try {
          const forms = await getForms(client, orderid, true);
          console.log(forms);
          let currentForm = 0;
          for (let i = 0; i < forms.length; i++) {
            if (formid === forms[i]) {
              currentForm = i;
              break;
            }
          }
          console.log(currentForm);
          let xfdf = '';
          if (refKey !== '') {
            const references = results[0].data.references;
            if (references && references !== null) {
              for (let i = 0; i < references.length; i++) {
                const reference = references[i];
                console.log('reference', reference);
                if (
                  reference.key === refKey &&
                  reference.forms &&
                  reference.forms.formData
                ) {
                  xfdf = reference.forms.formData[forms[currentForm]];
                }
              }
            }
          } else {
            if (taskId !== '') {
              if (results && results.forms) {
                xfdf = results.forms.formData[forms[currentForm]];
              }
            } else {
              if (results[0] && results[0].data && results[0].data.forms) {
                xfdf = results[0].data.forms.formData[forms[currentForm]];
              }
            }
          }
          console.log(xfdf);
          console.log('done');

          var host = `https://${client}`;
          if (process.env.NODE_ENV === 'development') {
            host = `http://${client}`;
          }

          const currentFormId = forms[currentForm];
          const content = await getDocumentArrayBuffer(
            `${host}/questions/form/${currentFormId}?orderid=${orderid}`
          );

          setState(prevState => ({
            ...prevState,
            client,
            currentForm,
            forms,
            finishedLoading: true,
            orderid,
            xfdf,
            currentFormId,
            content,
            host
          }));
        } catch (error) {
          console.log('caught error');
          console.log(error);
          setState(prevState => ({
            ...prevState,
            error: true,
            errorMessage: error
          }));
        }
      };

      loadData();
    },
    [params]
  );

  const formCompleted = async (formid, xfdf) => {
    // add formd data
  };

  const licenseKey = process.env.REACT_APP_PSPDFKIT_LICENSE;
  if (state.finishedLoading) {
    const title = `Form ${state.currentForm + 1} of ${state.forms.length}`;
    return (
      <div
        className="App"
        style={{
          backgroundColor: '#fff',
          maxWidth: '1170px',
          marginRight: 'auto',
          marginLeft: 'auto'
        }}
      >
        <img
          alt="form hero"
          src={state.host + '/casfiles/choice_fillableform_hero.png'}
        />
        {state.error && <div>{state.errorMessage}</div>}
        {state.finishedLoading && (
          <PSPDFKit
            documentId={state.currentForm}
            pdfUrl={state.content}
            licenseKey={licenseKey}
            baseUrl={baseUrl}
            completedForm={xfdf => {
              formCompleted(state.currentFormId, xfdf);
            }}
            hideToolbar={true}
            title={title}
            maxWidth="1170px"
            xfdf={state.xfdf}
          />
        )}
      </div>
    );
  }
  return null;
}

export default ChoiceViewer;
